module.exports = __webpack_public_path__ + "static/img/carousel_second.efcb19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AmongUs/carousel_second.png
// module id = 4Eo6
// module chunks = 1